<template>
  <div class="merchant-news-manage-page">
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">企业审核</h2>
        <p class="page-desc">审核合伙人提交的企业申请，管理审核状态</p>
      </div>
    </div>

    <div class="manage-card">
      <div class="filter-bar">
        <el-form :model="params" class="filter-form" inline @submit.native.prevent="search">
          <el-form-item label="审核状态">
            <el-select v-model="params.checkState" clearable placeholder="全部状态">
              <el-option
                  v-for="item in checkStates"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="filter-actions">
          <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
      </div>

      <div class="table-wrap">
        <el-table :data="records" stripe row-key="id" size="small">
          <el-table-column fixed label="ID" prop="id" width="80"/>
          <el-table-column label="店铺名" prop="store" min-width="150" show-overflow-tooltip/>
          <el-table-column label="店铺电话" prop="phone" width="120"/>
          <el-table-column label="昵称" prop="nickname" width="120" show-overflow-tooltip/>
          <el-table-column label="区域" prop="areaName" width="120" show-overflow-tooltip/>
          <el-table-column label="详细地址" prop="address" min-width="200" show-overflow-tooltip/>
          <el-table-column label="标题" prop="title" min-width="180" show-overflow-tooltip/>
          <el-table-column align="center" label="封面" width="80">
            <template slot-scope="{ row }">
              <el-image
                  :preview-src-list="[fileBaseUrl+row.coverImg]"
                  :src="fileBaseUrl+row.coverImg"
                  class="cover-thumb"
                  fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="newsTypeName" width="120" show-overflow-tooltip/>
          <el-table-column align="center" label="上下架" width="90">
            <template slot-scope="{ row }">
              <el-tag :type="row.state === '1' ? 'success' : 'info'" size="mini">
                {{ row.state === '1' ? '上架' : '下架' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="审核状态" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.checkState == '0' ? 'warning' : row.checkState == '1' ? 'danger' : 'success'" size="mini">
                {{ row.checkState == '0' ? '审核中' : row.checkState == '1' ? '审核失败' : '审核通过' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="{ row }">
              <div class="row-actions">
                <el-button size="mini" type="text" @click="toCheck(row)">去审核</el-button>
                <el-button v-if="row.checkState==='1'" size="mini" type="text" @click="onShowCheckReply(row)">失败原因</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-footer">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>

    <el-dialog
        title="失败原因"
        :visible.sync="showCheckReply"
        width="30%"
        center
    >
      {{checkReply}}
    </el-dialog>

  </div>
</template>

<script>

import Page from "@/components/Page.vue";
import page from "@/api/merchant/news/page";

export default {
  name: "MerchantNewsManage",
  components: {Page},
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      current:1,
      size:10,
      total: 0,
      params: {
        checkState:'0',
      },
      records: [],

      checkStates:[
        {
          value:'0',
          label:'审核中',
        },
        {
          value:'1',
          label:'审核失败',
        },
        {
          value:'2',
          label:'审核成功',
        },
      ],

      showCheckReply:false,
      checkReply:'',

    }
  },
  methods: {
    onShowCheckReply(row){
      this.checkReply=row.checkReply
      this.showCheckReply=true
    },
    toCheck(row){
      localStorage.setItem("checkMerchantNewsId", row.id)
      this.$router.push({
        name: "审核合伙人企业",
      })
    },
    search(){
      this.fetchData()
    },
    reset(){
      this.current=1
      this.params = {}
      this.fetchData()
    },
    fetchData(){
      page(this.current,this.size,this.params).then(res=>{
        this.records=res.data.data
        this.total=res.data.total
      })
    },
  },

  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
.merchant-news-manage-page {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  background: #f5f7fa;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 4px;

  &__info {
    flex: 1;
  }
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.manage-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.filter-bar {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
}

.filter-form {
  display: inline-block;
}

.filter-actions {
  display: inline-block;
  margin-left: 16px;
}

.table-wrap {
  padding: 0;
}

.cover-thumb {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #eef0f3;
  cursor: pointer;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.table-footer {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
}

@media (max-width: 768px) {
  .merchant-news-manage-page {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filter-bar {
    padding: 12px;
  }

  .table-wrap {
    padding: 0;
  }
}
</style>
